import { NavLink, useNavigate } from "react-router-dom";
import { Product } from "../../interface/interfaces";
import { useNotification } from "../../context/NotificationContext";
import { addToWishlist } from "../../api/requests";
import { AnimatePresence, motion } from "framer-motion";
import { useAuth } from "../../context/AuthContext";
import { useAnalytics } from "../../hooks/useAnalytics";
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'animate.css';
import { useEffect } from "react";




type PageProp = {
  data: Product,
  setProduct: (data: Product) => void,
  index: number
}

const ProductCard = ({ data, index, setProduct }: PageProp) => {

   useEffect(() => {
    AOS.init({
      duration: 800, // animation duration in ms
      once: true, // whether animation should happen only once - while scrolling down
    });
  }, []);



  const navigate = useNavigate()
  const { notify } = useNotification()
  const {isLoggedIn}= useAuth()
  const { trackViewItem, trackAddToWishlist } = useAnalytics()

  function hasDiscount(price: number, discountPrice: number) {
    return discountPrice < price && discountPrice > 0;
  }

  function discountPercent(price: number, discountPrice: number) {
    const percent = ((price - discountPrice) / price) * 100;
    return `${percent.toFixed(0)}% OFF`;
  }

  function averageRating(reviews: any[]) {
    if (!reviews.length) return '0';
    const sum = reviews.reduce((acc: any, r: { rating: any; }) => acc + r.rating, 0);
    const avg = sum / reviews.length;
    return avg.toPrecision(1);
  }

  // function productAverageRating(reviews: any[]) {
  //   if (!reviews.length) return 0.0;
  //   const sum = reviews.reduce((acc: any, r: { rating: any; }) => acc + r.rating, 0);
  //   return sum / reviews.length;
  // }


  const goProduct = async (id: string) => {
    // Track view item event
    await trackViewItem(data);
    navigate(`/product/${id}/${data.isLiked? 'liked': ''}`)
  }

  const setWishlistLoader = (value: boolean) => {

    setProduct({ ...data, isLiking: value })

  }

  function setWishlistLike(value: boolean) {
    setProduct({ ...data, isLiked: value })
  }

  const wishlistHandler = async () => {

    if(!isLoggedIn()){
      notify.error('Sign in is required')
      return
    }


    if (!data.isLiked) {
      setWishlistLoader(true)
      addToWishlist(data.productId).then(async () => {
        setWishlistLoader(false)
        setWishlistLike(true)
        notify.success('Product added to wishlist')
        // Track add to wishlist event
        await trackAddToWishlist(data);
      },
        (error:any) => {
          setWishlistLoader(false)
          notify.error(error.message)
        }
      )
    }


  }



  return (
    <div data-aos="fade-up" className='eachproduct animate__animated animate__fadeIn animate__fast' key={index}>

      <div className='imageCont'>
        <div className='upFlex'>

          {data.tag && data.tag !== '' && (<div className='tag'>{data.tag}</div>)}


          <div className={`likebtn ${data.isLiked ? 'liked' : ''}`} onClick={wishlistHandler}>

            <AnimatePresence mode="wait">
              {data.isLiking && (<motion.div
                key="spinner"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.2 }}
                className='smallspinner'></motion.div>)}

              {!data.isLiking && (
                <motion.svg
                  key={data.isLiked ? 'liked' : 'unliked'} // triggers exit/enter animation
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: [1.5, 0.9, 1], opacity: 1 }}
                  exit={{ scale: 0.6, opacity: 0 }}
                  transition={{ duration: 0.3, ease: 'easeOut' }}

                  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.5436 4C13.5005 4 12.0005 7 12.0005 7C12.0005 7 10.5005 4 7.45735 4C4.98423 4 3.02579 6.06906 3.00048 8.53797C2.94892 13.6628 7.06595 17.3073 11.5786 20.3702C11.703 20.4548 11.85 20.5001 12.0005 20.5001C12.151 20.5001 12.2979 20.4548 12.4224 20.3702C16.9345 17.3073 21.0516 13.6628 21.0005 8.53797C20.9752 6.06906 19.0167 4 16.5436 4Z" stroke="#B8B8B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </motion.svg>)}

            </AnimatePresence>



          </div>

        </div>

        <img className='productImg' alt='product' src={data.imgUrl} onClick={() => goProduct(data.productId)}>
        </img>

      </div>

      <NavLink to={`/product/${data.productId}/${data.isLiked? 'liked': ''}`}>
        <div className='textCont'>
          <div className='productName'>{data.name}</div>


          <div className='productPrice'>

            <div className='currentPrice'> <span>{data.price_data.currency_symbol}</span><span>{(data.price_data.current_price).toLocaleString()}</span> </div>

            {hasDiscount(data.price!, data.discount_price!) && (<div className='prevPrice'><span className='currrency_symbol'>{data.price_data.currency_symbol}</span><span>{(data.price_data.prev_price!).toLocaleString()}</span></div>)}

            {hasDiscount(data.price!, data.discount_price!) && (<div className='percentOff'>{discountPercent(data.price!, data.discount_price!)}</div>)}

          </div>


          <div className='productReception'>

            {data.reviews >= 1 && (<div className='stars'>


              {[...Array(Number(averageRating(data.reviewsData!)))].map((_, i) => (<div className='svgicon' key={i}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.44828 3.57658C7.03668 2.11017 7.33088 1.37605 7.80929 1.27432C7.93498 1.24759 8.06488 1.24759 8.19056 1.27432C8.66806 1.37513 8.96318 2.10926 9.55157 3.57658C9.8861 4.41061 10.0529 4.82762 10.3663 5.11173C10.4549 5.19116 10.5497 5.26143 10.6505 5.32253C11.0125 5.54158 11.4643 5.5819 12.368 5.66255C13.8977 5.80003 14.662 5.86785 14.8957 6.30411C14.9441 6.39453 14.9769 6.49243 14.9929 6.59373C15.0708 7.08222 14.508 7.59272 13.3835 8.61646L13.0719 8.90058C12.5458 9.37899 12.2837 9.6182 12.1315 9.91607C12.0401 10.0952 11.9788 10.2881 11.9501 10.4871C11.9024 10.8179 11.9794 11.1653 12.1334 11.8591L12.1884 12.1065C12.4642 13.3511 12.6026 13.9734 12.4303 14.2786C12.3541 14.4138 12.2449 14.5275 12.1128 14.6089C11.9807 14.6903 11.8301 14.7369 11.6751 14.7442C11.325 14.7616 10.831 14.3593 9.84211 13.5537C9.19139 13.023 8.86603 12.7582 8.50492 12.6546C8.1749 12.56 7.82495 12.56 7.49493 12.6546C7.13383 12.7582 6.80755 13.023 6.15683 13.5537C5.16884 14.3584 4.67484 14.7616 4.32382 14.7451C4.16888 14.7376 4.01841 14.6908 3.88649 14.6092C3.75456 14.5276 3.64551 14.4139 3.56953 14.2786C3.39723 13.9734 3.53562 13.3511 3.81149 12.1065L3.86648 11.8591C4.02045 11.1653 4.09744 10.8179 4.04978 10.4871C4.02102 10.2881 3.95971 10.0952 3.86831 9.91607C3.71617 9.6182 3.45405 9.37899 2.92797 8.90058L2.61636 8.61646C1.49181 7.59364 0.929989 7.08222 1.00698 6.59373C1.02293 6.49243 1.05577 6.39453 1.10413 6.30411C1.33783 5.86785 2.10312 5.80003 3.63185 5.66255C4.53553 5.5819 4.98737 5.54158 5.34847 5.32345C5.44979 5.26222 5.54494 5.19131 5.63259 5.11173C5.94695 4.82762 6.11375 4.41061 6.44828 3.57658Z" fill="#FFC453" stroke="#FFC453" stroke-width="1.83301" />
                </svg>
              </div>))}


              {[...Array((5 - Number(averageRating(data.reviewsData!))))].map((_, i) => (<div className='svgicon stripped' key={i}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.44828 3.57658C7.03668 2.11017 7.33088 1.37605 7.80929 1.27432C7.93498 1.24759 8.06488 1.24759 8.19056 1.27432C8.66806 1.37513 8.96318 2.10926 9.55157 3.57658C9.8861 4.41061 10.0529 4.82762 10.3663 5.11173C10.4549 5.19116 10.5497 5.26143 10.6505 5.32253C11.0125 5.54158 11.4643 5.5819 12.368 5.66255C13.8977 5.80003 14.662 5.86785 14.8957 6.30411C14.9441 6.39453 14.9769 6.49243 14.9929 6.59373C15.0708 7.08222 14.508 7.59272 13.3835 8.61646L13.0719 8.90058C12.5458 9.37899 12.2837 9.6182 12.1315 9.91607C12.0401 10.0952 11.9788 10.2881 11.9501 10.4871C11.9024 10.8179 11.9794 11.1653 12.1334 11.8591L12.1884 12.1065C12.4642 13.3511 12.6026 13.9734 12.4303 14.2786C12.3541 14.4138 12.2449 14.5275 12.1128 14.6089C11.9807 14.6903 11.8301 14.7369 11.6751 14.7442C11.325 14.7616 10.831 14.3593 9.84211 13.5537C9.19139 13.023 8.86603 12.7582 8.50492 12.6546C8.1749 12.56 7.82495 12.56 7.49493 12.6546C7.13383 12.7582 6.80755 13.023 6.15683 13.5537C5.16884 14.3584 4.67484 14.7616 4.32382 14.7451C4.16888 14.7376 4.01841 14.6908 3.88649 14.6092C3.75456 14.5276 3.64551 14.4139 3.56953 14.2786C3.39723 13.9734 3.53562 13.3511 3.81149 12.1065L3.86648 11.8591C4.02045 11.1653 4.09744 10.8179 4.04978 10.4871C4.02102 10.2881 3.95971 10.0952 3.86831 9.91607C3.71617 9.6182 3.45405 9.37899 2.92797 8.90058L2.61636 8.61646C1.49181 7.59364 0.929989 7.08222 1.00698 6.59373C1.02293 6.49243 1.05577 6.39453 1.10413 6.30411C1.33783 5.86785 2.10312 5.80003 3.63185 5.66255C4.53553 5.5819 4.98737 5.54158 5.34847 5.32345C5.44979 5.26222 5.54494 5.19131 5.63259 5.11173C5.94695 4.82762 6.11375 4.41061 6.44828 3.57658Z" fill="#FFC453" stroke="#FFC453" stroke-width="1.83301" />
                </svg>
              </div>))}


            </div>)}



            {data.reviews >= 1 && (<div className='reviews'>({data.reviews} review{data.reviews > 1 ? 's' : ''})</div>)}


          </div>
        </div>
      </NavLink>


    </div>
  )
}


export default ProductCard;